import React from 'react';
import Shop from '../assets/shop.svg';
import MobileShopping from '../assets/mobile-shopping.svg';
import How from '../components/How';
import NPS from '../components/NPS';
import SmallFeatureSet from '../components/SmallFeatureSet';
import PricingSection from '../components/PricingSection';
import Grow from '../components/Grow';
import Layout from '../components/layout';
import trackLead from '../../trackLead';
import CTA from '../components/CTA';
import SEO from '../components/seo/seo';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" pathname="/" />
    <div
      className="flex pt-12 pb-20 hero bg-gray-100"
      style={{ marginTop: '-82px' }}
    >
      <div className="container flex flex-col justify-center items-center relative">
        <h1 className="flex font-sans text-shop-dark-green self-center text-4xl md:text-5xl tracking-wide">
          ShopFeedback
        </h1>
        <h3 className="font-sans text-shop-dark-green self-center text-center text-lg font-normal mt-2">
          Collect feedback, take action, and create happier customers
        </h3>
        <div className="flex">
          <a
            className="rounded-full shadow mt-12 inline-flex items-center justify-center px-6 py-2 border border-transparent text-gray-900 leading-5 hover:bg-shop-dark-green hover:text-white font-medium rounded-full bg-shop-light-green focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
            href="https://apps.shopify.com/shopfeedback"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackLead()}
          >
            Start Your 30-day Free Trial
          </a>
        </div>
      </div>
    </div>

    <div className="hero-angle" />
    <div className="container flex flex-row flex-wrap-reverse z-10 mb-20 sm:mt-8 relative">
      <div className="w-full md:w-2/3 xl:w-1/2">
        <h2 className="leading-normal font-sans text-shop-dark-green text-2xl">
          Are your customers happy?
        </h2>
        <p className="leading-normal font-sans text-shop-dark-green mt-4">
          As a busy shop owner, you wear all the hats. You are designing your
          products, tweaking your website, shipping orders, and everything
          in-between, however do you know if your customers are happy with their
          shopping experience? Do you even have the time to ask them? How do you
          get quality actionable feedback?
          <br />
          <br />
          ShopFeedback is for you.
        </p>
      </div>
      <div className="w-full md:w-1/3 xl:w-1/2 content-center justify-center flex mb-8 sm:mb-0">
        <Shop className="self-center" />
      </div>
    </div>

    <div className="container flex flex-row flex-wrap mb-20">
      <div className="w-full md:w-1/3 xl:w-1/2 content-center justify-center flex">
        <MobileShopping className="self-center mb-8 sm:mb-0" />
      </div>
      <div className="w-full md:w-2/3 xl:w-1/2 sm:pl-8">
        <h2 className="leading-normal font-sans text-shop-dark-green text-2xl">
          What is ShopFeedback?
        </h2>
        <p className="leading-normal font-sans text-shop-dark-green mt-4">
          You could send a long survey asking many questions about all sorts of
          topics, however, your customers aren't likely to take the time to fill
          it out.
        </p>
        <p className="leading-normal font-sans text-shop-dark-green mt-4">
          That's where the Net Promoter Score or NPS® and ShopFeedback come in.
          It's a one question, one-click survey, sent via email, that customers
          are much more likely to answer, and it gives you the quality feedback
          you need to grow your sales, and create happier customers.
        </p>
        {/* <p className="leading-normal font-sans text-shop-dark-green mt-4">
              ShopFeedback is a Shopify app that helps you get automatic
              actionable feedback from your customers. Automatically survey your
              customers after they have received their order. Find out what's
              working, what's not and everything in between.
            </p> */}
      </div>
    </div>

    <NPS />
    <Grow />
    <How />
    <SmallFeatureSet />
    {/* <PricingSection isPage title="Actionable feedback at an affordable price" /> */}
    {/* <EmailSection /> */}
    {/* <Divider /> */}
    <CTA />

    {/* last div */}
  </Layout>
);

export default IndexPage;
